import script from "./tag-input.vue?vue&type=script&setup=true&lang=js"
export * from "./tag-input.vue?vue&type=script&setup=true&lang=js"

import "./tag-input.vue?vue&type=style&index=0&id=8fc7fc1c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8fc7fc1c"]])

export default __exports__